module.exports = __webpack_public_path__ + "static/media/Sec-1_HomePageMobile_TH.f302f902.png";